import _ from 'lodash'
import { Tooltip, TooltipType } from '../tooltip'
import { Button } from '../button'
import { ControlGroup } from '../control-group'

export default {
  name: 'KTooltipAction',
  mixins: [Tooltip],
  props: {
    // 动作集合：[{ label, action, disabled, loading, icon }]
    //  label: 展示标签
    //  action: 动作标识
    //  disabled: 禁用
    //  loading: 处理中状态
    actions: {
      type: Array,
      // []
      default() {
        return []
      },
    },
  },
  data() {
    return {
      tooltipType: TooltipType.TooltipAction,
    }
  },
  methods: {
    renderAction({ label, action, disabled, loading, icon }) {
      return (
        <Button
          class="km-tooltip-action__button"
          type={this.type}
          icon={icon}
          loading={loading}
          disabled={disabled}
          plain={this.plain}
          outlined={this.outlined}
          square={!label}
          onClick={() => {
            this.showPopper = false
            this.$emit('action', action, { label, action, disabled, loading, icon })
          }}
        >
          {label}
        </Button>
      )
    },
    renderContent() {
      return (
        <ControlGroup>
          {
            _.map(this.actions, action => this.renderAction(action))
          }
        </ControlGroup>
      )
    },
  },
}
